import { Component, computed } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ToastService } from '../../../core/services/toast.service';
@Component({
  selector: 'toast',
  templateUrl: './toast.component.html',
  animations: [
    trigger('slideIn', [
      transition(
        ':enter',
        [
          style({ opacity: 0, transform: '{{enter}}' }),
          animate('200ms ease-out', style({ opacity: 1, transform: 'translate(0, 0) scale(1)' })),
        ],
        { params: { enter: 'translateY(-100%)' } },
      ),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'scale(0.9)' })),
      ]),
    ]),
  ],
})
export class ToastComponent {
  constructor(public toastService: ToastService) { }

  containerClass = computed(() => {
    let pos;
    if (this.toastService.toasts().length > 0) {
      pos = this.toastService.toasts()[this.toastService.toasts().length - 1].position;
    } else {
      pos = this.toastService.position();
    }
    switch (pos) {
      case 'top-right':
        return 'top-0 right-0 items-end';
      case 'top-left':
        return 'top-0 left-0 items-start';
      case 'bottom-right':
        return 'bottom-0 right-0 items-end';
      case 'bottom-left':
        return 'bottom-0 left-0 items-start';
      case 'top-center':
        return 'top-0 left-1/2 -translate-x-1/2 items-center';
      case 'bottom-center':
        return 'bottom-0 left-1/2 -translate-x-1/2 items-center';
      default:
        return 'top-0 right-0 items-end';
    }
  });

  toastClasses = {
    success: 'bg-white text-gray-700 dark:bg-gray-800 dark:text-gray-200',
    error: 'bg-white text-gray-700 dark:bg-gray-800 dark:text-gray-200',
    warning: 'bg-white text-gray-700 dark:bg-gray-800 dark:text-gray-200',
    info: 'bg-white text-gray-700 dark:bg-gray-800 dark:text-gray-200',
  };

  iconClasses = {
    success: 'text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200',
    error: 'text-red-500 bg-red-100 dark:bg-red-800 dark:text-red-200',
    warning: 'text-orange-500 bg-orange-100 dark:bg-orange-800 dark:text-orange-200',
    info: 'text-blue-500 bg-blue-100 dark:bg-blue-800 dark:text-blue-200',
  };

  iconPaths = {
    success:
      'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z',
    error:
      'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z',
    warning:
      'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z',
    info: 'M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z',
  };
}
